import { connect } from 'react-redux';
import ScannerTest from './scannerTest';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state) => ({
    parentMaterials: state.siteListingReducer.parentMaterials
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScannerTest);
